














































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import AppConsts from "@/lib/appconst";
import ProductStatementReportOutput from "@/store/entities/product-statement-report-output";
import ProductForSelect from "@/store/entities/products/product-for-select";
import _ from "lodash";
class PageProductStatementReportRequest {
  sku: string;
  clientCode: string;
  warehouseCode: string;
  assetTypeCode: string;
  conditionTypeCode: string;
  fromDate?: Date;
  toDate?: Date;
}
@Component
export default class ProductStatementReport extends AbpBase {
  //filters
  pagerequest: PageProductStatementReportRequest = new PageProductStatementReportRequest();
  creationTime: Date[] = [];
  reportResult: ProductStatementReportOutput = new ProductStatementReportOutput();
  conditionTypes = [];
  assetTypes = [];
  clients = [];
  warehouses = [];
  spinShow: boolean = false;
  objectLoading: boolean = false;
  products: Array<ProductForSelect> = new Array<ProductForSelect>();
  searchProduct_OnPress = _.debounce(
    this.searchProductForSelect,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  get totalItems() {
    var argus = ["0"];
    if (
      !Util.isNull(this.reportResult) &&
      !Util.isNull(this.reportResult.items)
    ) {
      argus = [this.reportResult.items.length.toString()];
    }
    return Util.L("TotalItems", "", ...argus);
  }
  viewDateWarning() {
    var argus = [AppConsts.reportRangeDays.range180.toString()];
    return Util.L("RangeDaysTooltip", "", ...argus);
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  getClients() {
    var re = this.$store.state.client.clientsForSelect;
    this.$set(
      this.pagerequest,
      "clientCode",
      re.length === 0 ? "" : re[0].code
    );
    this.clients = re;
  }
  getWarehouses() {
    var re = this.$store.state.warehouse.warehousesForSelect;
    this.$set(
      this.pagerequest,
      "warehouseCode",
      re.length === 0 ? "" : re[0].id
    );
    this.warehouses = re;
  }
  getConditionTypes() {
    var re = this.$store.state.masterData.conditionTypes;
    this.$set(
      this.pagerequest,
      "conditionTypeCode",
      re.length === 0 ? "" : re[0].id
    );
    this.conditionTypes = re;
  }
  getAssetTypes() {
    var re = this.$store.state.client.clientAssetTypes;
    this.$set(
      this.pagerequest,
      "assetTypeCode",
      re.length === 0 ? "" : re[0].id
    );
    this.assetTypes = re;
  }
  get list() {
    return this.reportResult.items;
  }
  get loading() {
    return this.$store.state.report.loading;
  }
  async exportToExcel() {
    this.buildPageRequest();
    await this.$store.dispatch({
      type: "report/exportProductStatement",
      data: this.pagerequest,
    });
  }
  buildPageRequest() {
    var clientCode = this.pagerequest.clientCode;
    var warehouseCode = this.pagerequest.warehouseCode;
    if (this.isClient()) {
      this.pagerequest.clientCode = this.$store.state.session.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.$store.state.session.tenant.tenancyName;
    }
    if (this.creationTime.length > 0) {
      this.pagerequest.fromDate = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.toDate = this.creationTime[1];
    }
  }
  async getpage() {
    this.buildPageRequest();
    //filters
    await this.$store
      .dispatch({
        type: "report/getProductStatementReport",
        data: this.pagerequest,
      })
      .then((result) => {
        this.reportResult = result;
      })
      .catch(() => {
        this.$store.commit(`report/setIsLoading`, false);
      });
  }
  async changeClientCode() {
    await this.$store
      .dispatch({
        type: "client/getClientAssetTypeServices",
        data: this.pagerequest.clientCode,
      })
      .then((resutl) => {
        this.getAssetTypes();
      });
  }
  async searchProductForSelect(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.products = await this.$store.dispatch({
      type: "product/searchProductForSelect",
      data: {
        clientCode: this.pagerequest.clientCode,
        keyWord: keyword,
      },
    });
    this.objectLoading = false;
  }
  async changeProduct() {
    if (
      Util.isNull(this.pagerequest.sku) ||
      Util.isEmpty(this.pagerequest.sku)
    ) {
      return;
    }
    var product = _.find(this.products, ["sku", this.pagerequest.sku]);
    if (Util.isNull(product)) {
      Util.showErrorMsg(this, "Error.ProductNotExist");
    }
  }
  columns = [
    {
      title: Util.L("TransDate"),
      width: 170,
      key: "transDate",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.transDate));
      },
    },
    {
      title: Util.L("ActionName"),
      width: 150,
      key: "actionTypeName",
    },
    {
      title: Util.L("RefCode"),
      width: 150,
      key: "refCode",
    },
    {
      title: Util.L("RefExternalCode"),
      width: 150,
      key: "refExternalCode",
      slot: "refExternalCode",
    },
    {
      title: `${Util.L("SoRequestCode")}/ ${Util.L("ReturnSalesOrder")}`,
      width: 150,
      key: "rO_SOR_ExternalCode",
    },
    {
      title: Util.L("AOGroupCode"),
      width: 150,
      key: "aoGroupCode",
    },
    {
      title: Util.L("RefType"),
      width: 150,
      key: "refTypeName",
    },
    {
      title: Util.L("Customer"),
      width: 150,
      key: "customerName",
    },
    {
      title: Util.L("IncreaseQty"),
      width: 100,
      key: "increaseQty",
      align: "right",
      className: "increaseCell",
      render: (h: any, params: any) => {
        if (params.row.increaseQty > 0)
          return h("span", Util.toViewNumberString(params.row.increaseQty));
        return h("span", "");
      },
    },
    {
      title: Util.L("DecreaseQty"),
      width: 100,
      key: "decreaseQty",
      align: "right",
      className: "decreaseCell",
      render: (h: any, params: any) => {
        if (params.row.decreaseQty > 0)
          return h("span", Util.toViewNumberString(params.row.decreaseQty));
        return h("span", "");
      },
    },
    {
      title: Util.L("RunningBalanceQty"),
      width: 100,
      key: "runningBalanceQty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.runningBalanceQty));
      },
    },
  ];
  async created() {
    this.spinShow = true;
    try {
      await this.$store
        .dispatch({
          type: "client/getListForSelect",
        })
        .then((result) => {
          this.getClients();
        });
      await this.$store
        .dispatch({
          type: "masterData/getFeatureConditionTypes",
          data: { featureCode: AppConsts.featureConditionType.Report },
        })
        .then((result) => {
          this.getConditionTypes();
        });
      await this.$store
        .dispatch({
          type: "warehouse/getListForSelect",
        })
        .then((result) => {
          this.getWarehouses();
        });
      if (this.isClient()) {
        this.pagerequest.clientCode = this.$store.state.session.client.code;
      }
      this.changeClientCode();
      this.creationTime = Util.buildDefaultViewDate(
        AppConsts.reportRangeDays.range180
      );
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
